export default __webpack_public_path__ + "static/media/presentation-chart.4e658b0a.svg";